import { DatePicker } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceDatePicker",
  // extends: DatePicker,
  mixins: [DatePicker, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    pickerDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
